import React from 'react';
import { useRouter } from 'next/router';

import { GetStaticProps, NextPage } from 'next';
import absoluteUrl from 'next-absolute-url';
import { NextSeo } from 'next-seo';
import ListingApi from 'src/api/listings';
import { IListing } from 'src/interface';
import ListingsDetails from 'src/components/ListingDetails';
import cookiee from 'cookie';
import SearchBanner from 'src/components/Common/pageBanner';
import Error from 'next/error';
// import { AdHorizontal } from '../../../index';
// import AdBanner from '../../../../components/Adsense';

type TProps = {
  canonicalUrl: string;
  listing?: IListing;
  related?: IListing[] | null;
  more?: IListing[] | null;
  err?: boolean;
};
const ListingDetailPage: NextPage<TProps> = ({ canonicalUrl, listing, related, more, err }) => {
  const router = useRouter();

  // If the page is not yet generated, this will be displayed
  // initially until getStaticProps() finishes running
  if (router.isFallback) {
    return <div>Loading...</div>;
  }
  if (err) {
    return <Error statusCode={500} />;
  }
  return (
    <>
      <NextSeo
        canonical={canonicalUrl}
        title={listing?.title}
        description={listing?.short_description}
        openGraph={{
          url: canonicalUrl,
          title: listing?.title,
          description: listing?.short_description,
          images: [
            {
              url: listing?.images[0] || '',
              alt: `${listing?.title}`,
            },
          ],
        }}
      />
      <SearchBanner />
      {/* <AdHorizontal>
        <AdBanner slotId="4100436110" />
      </AdHorizontal> */}
      {listing && <ListingsDetails listing={listing} related={related} more={more} />}
      {/* <AdHorizontal>
        <AdBanner slotId="9529706829" />
      </AdHorizontal> */}
    </>
  );
};
export async function getStaticPaths() {
  return {
    paths: [],
    fallback: true,
  };
}
export const getStaticProps: GetStaticProps = async (ctx) => {
  const { params } = ctx;
  // const { origin } = absoluteUrl(req);
  try {
    // const authCookie = req.headers.cookie;
    // const token =
    //   (authCookie &&
    //     cookiee.parse(authCookie).auth &&
    //     JSON.parse(cookiee.parse(authCookie).auth).token) ||
    //   null;
    const { data } = await ListingApi.fetchListingDetails(params?.listingId || '', null);
    const { listing, related, more } = data;
    return {
      props: {
        canonicalUrl: `https://rentable.pk/${params?.parentCategory}/${params?.childCategory}/${params?.listingId}`,
        listing,
        related,
        more,
        query: params,
        revalidate: 250,
      },
    };
  } catch (err) {
    console.log(err);
  }
  return {
    props: {
      canonicalUrl: `https://rentable.pk/${params?.parentCategory}/${params?.childCategory}/${params?.listingId}`,
      err: true,
      revalidate: 250,
    },
  };
};
export default ListingDetailPage;
